module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Duqqy","short_name":"duqqy","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"standalone","icon":"src/fav/fav.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"5ec7a3c0df0339e06927df2a25d45923"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
